import { EuiPage, EuiPanel } from "@elastic/eui";
import client from "api/Client";
import { PriceForm } from "components/PriceForm";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

export default function NewPrice() {
    const [price, setPrice] = useState(undefined);
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            client.get(`/v1/prices/${id}`).then((result) => {
                setPrice(result.data);
            });
        }
    }, [id]);

    return (
        <EuiPage>
            <EuiPanel>
                <PriceForm price={price} />
            </EuiPanel>
        </EuiPage>
    );
}
